import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import EditForm from '../../../../../../features/components/Forms/EditForm'
import RemainingCampaignImpressionsBudgetFields from '../../../../UploadAdCreative/ImpressionsBudgetSection/RemainingCampaignImpressionsBudgetFields'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import {
  calculateBudgetFromImpressions,
  calculateImpressionsFromBudget
} from '../../../../UploadAdCreative/ImpressionsBudgetSection/helpers'

import {
  campaignUpdateErrorSelector,
  campaignUpdateIsLoadingSelector,
  campaignWasUpdatedSelector
} from '../../../../../../modules/selectors/campaigns'
import { rightSelector } from '../../../../../../modules/selectors/rights'
import { clearUpdateCampaign, updateCampaign } from '../../../../../../modules/actions/campaigns'

import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'
import { DV_360_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { IMPRESSIONS } from '../../../../UploadAdCreative/fields'
import { BUDGET_LIFETIME } from '../../../../CampaignForms/fields'
import { getImpressionsValidationsSchema } from '../../../../../ReusableFormSections/reusableBudgetSections/remainingImpressionsValidation'

const ImpressionsBudgetSectionForm = ({
  editItemData: campaign,
  remainingImpressions,
  updateOptions,
  title,
  ...formProps
}) => {
  const dispatch = useDispatch()

  const { ad_account_id: adAccountId } = campaign

  const { bid_cap: rightBidCap } = useSelector(rightSelector)

  const successUpdate = useSelector(campaignWasUpdatedSelector)

  const handleSubmit = useCallback(
    values => {
      const budgetLifetime = calculateBudgetFromImpressions({
        impressions: values[IMPRESSIONS],
        rightBidCap
      })

      const updateCampaignData = {
        meta: {
          [HISTORY_META_EDIT_SECTION]: title
        },
        account: adAccountId,
        [BUDGET_LIFETIME]: budgetLifetime
      }

      dispatch(updateCampaign(updateCampaignData, campaign.id, DV_360_PLATFORM, updateOptions))
    },
    [dispatch, campaign.id, title, adAccountId, updateOptions, rightBidCap]
  )

  const initialCampaignImpressions = useMemo(() => {
    return calculateImpressionsFromBudget({
      budget: campaign?.budget_lifetime,
      rightBidCap
    })
  }, [campaign, rightBidCap])

  const initialValues = useMemo(() => {
    return {
      [IMPRESSIONS]: initialCampaignImpressions
    }
  }, [initialCampaignImpressions])

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit,
    validationSchema: getImpressionsValidationsSchema(remainingImpressions, initialCampaignImpressions)
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const handleClearUpdateCampaign = useCallback(() => {
    dispatch(clearUpdateCampaign())
  }, [dispatch])

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={successUpdate}
      clearEditItem={handleClearUpdateCampaign}
      errorSelector={campaignUpdateErrorSelector}
      isLoadingSelector={campaignUpdateIsLoadingSelector}
      {...formProps}
    >
      <RemainingCampaignImpressionsBudgetFields formik={formik} remainingImpressions={remainingImpressions} />
    </EditForm>
  )
}

export default ImpressionsBudgetSectionForm
